var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.show)?_c('div',{staticClass:"scroll-up d-flex align-items-center justify-content-center p-2",on:{"click":_vm.up}},[_c('font-awesome-icon',{attrs:{"icon":"arrow-up","size":"lg"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }